import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { isStoredSuperAdminSessionValid } from "../helpers/super_admin_auth_storage";

interface SuperAdminProtectedProps {
  children: React.ReactNode;
}

const SuperAdminProtected = ({ children }: SuperAdminProtectedProps) => {
  const location = useLocation();

  if (!isStoredSuperAdminSessionValid()) {
    return (
      <Navigate to="/super-admin/login" state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export default SuperAdminProtected;
